// extracted by mini-css-extract-plugin
export default {"specialities":"speciality_specialities__OPqpa","itemContainer":"speciality_itemContainer__j3Pwz","itemMask":"speciality_itemMask__X9+nH","itemBox":"speciality_itemBox__aIQK1"};